import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=6dd23fe3&scoped=true&"
import script from "./Person.vue?vue&type=script&lang=ts&"
export * from "./Person.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd23fe3",
  null
  
)

export default component.exports